import { render, staticRenderFns } from "./NoContent.vue?vue&type=template&id=6a48276d&scoped=true"
import script from "./NoContent.vue?vue&type=script&lang=js"
export * from "./NoContent.vue?vue&type=script&lang=js"
import style0 from "./NoContent.vue?vue&type=style&index=0&id=6a48276d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a48276d",
  null
  
)

export default component.exports